import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, Events } from 'ionic-angular';
import { EventCreatePage } from '../event-create/event-create';
import { EventsProvider } from '../../providers/events/events.provider';
import { CategoriesProvider } from '../../providers/categories/categories.provider';
import { EventPage } from '../event/event';
import { AuthProvider } from '../../providers/auth/auth.provider';
import { LoginModalPage } from '../login-modal/login-modal';
/**
 * Generated class for the ExplorePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-events',
  templateUrl: 'events.html',
})
export class EventsPage {
  search: any = "";
  events_list: any = [];
  categories: any = [];
  cardSelectorModal: any;
  want_to_create_event = false;

  constructor(
    public navCtrl: NavController, 
    public modalCtrl: ModalController, 
    public navParams: NavParams,
    private eventsProvider: EventsProvider,
    private events: Events,
    private authProvider: AuthProvider,
    private categoriesProvider: CategoriesProvider
  ) {  

    this.cardSelectorModal = this.modalCtrl.create(LoginModalPage,{});
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad ExplorePage');
  }
  ionViewDidEnter() {
    this.refresh();
  }

  async refresh(){
    this.events_list = await this.eventsProvider.getEvents();
    // console.log("this.events",this.events)

    this.categories = await this.categoriesProvider.getCategories();
    // console.log("this.categories",this.categories)
  }

  goToEvent(event){
    this.navCtrl.push(EventPage, {event:event});
  }

  goToEventCreate(){
    if(this.authProvider.isConnected()){
      let modal = this.modalCtrl.create(EventCreatePage,{});
      modal.present();
      modal.onDidDismiss(async data => {
        // console.log("data",data);
        this.refresh();
      });
    }
    else {
      // console.log('checkLogin offline');
      this.want_to_create_event = true;
      this.cardSelectorModal.onDidDismiss(data => {
        // console.log("data",data);
        this.want_to_create_event = null;
        if(data != null){
        }
      });
      this.cardSelectorModal.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/events/events.ts